import c, { css as s } from "styled-components";
import l from "./atoms-v21009.js";
import { Base as p } from "./atoms-v2777.js";
const f = ({
  theme: o,
  type: t,
  variant: e
}) => {
  const r = l(o.tokens, ["body", "heading", "helper"]), n = t && t in r && r[t];
  if (n && e && typeof n == "object" && e in n) {
    const i = n[e];
    if (typeof i == "object" && "toJS" in i && typeof i.toJS == "function")
      return i.toJS();
  }
  return console.error(
    `Error: Unable to parse style object. The variant “${e}” doesn’t exist for the type “${t}”.`
  ), {};
}, x = c.div`
  ${p}

  color: ${({ $colorTheme: o = "light", theme: t }) => t == null ? void 0 : t.get(`tokens.text.${o}.primary`)};
  font-synthesis: none;

  ${({ $isSkeleton: o, $type: t, $variant: e, theme: r }) => !o && f({ theme: r, type: t, variant: e })}

  ${({ $isSkeleton: o }) => o && s`
      display: flex;
      flex-direction: column;
      row-gap: 8px;
    `}

  ${({ $lineClamp: o }) => o && s`
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: ${o};
      overflow: hidden;
    `}
`;
export {
  x as Text
};
